import { Summary } from '@livekatsomo/models';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import { SummaryView } from '../SummaryView/SummaryView';

export interface SummaryCardProps {
  title?: string;
  /**
   * The summary to display in the card.
   */
  summary?: Summary;
  /**
   * Function to call when the edit button is clicked.
   */
  onEdit: () => void;
}

/**
 * A memoized component that displays a summary and an edit button in a card.
 * @param summary The summary to display in the card.
 * @param onEdit Function to call when the edit button is clicked.
 * @returns A React component that displays a summary and an edit button in a card.
 */
export const SummaryCard = memo(function SummaryCard({
  title,
  summary,
  onEdit,
}: SummaryCardProps) {
  const { t } = useTranslation();
  return (
    <Card
      sx={{
        gridColumnStart: 1,
        gridColumnEnd: -1,
      }}
      aria-labelledby="event-summary-card-header"
    >
      <CardHeader
        title={title ? title : t('Summary')}
        id="event-summary-card-header"
      />
      <CardContent>
        {summary ? <SummaryView summary={summary} /> : null}
      </CardContent>
      <CardActions>
        <Button size="small" onClick={onEdit}>
          {t('Edit')}
        </Button>
      </CardActions>
    </Card>
  );
});
